import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getBusinessProcessesActivePlanWorks: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]
				.GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS,
	},

	getBusinessProcessesActivePlanWorkPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]
				.GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS_POPUP,
	},

	getBusinessProcessesActivePlanWorksPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]
				.GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS_PREVIEW,
	},

	getBusinessProcessesActivePlanWork: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.BUSINESS_PROCESSES_ACTIVE_PLAN_WORKS]
				.GET_BUSINESS_PROCESSES_ACTIVE_PLAN_WORK,
	},
}
